import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import ExecutorList from '../ExecutorList/ExecutorList';
import ShutdownDesc from '../ShutdownDesc/ShutdownDesc';
import styles from './ShutdownDetails.module.scss';

const renderDate = (date) => (
  <span>
    {moment.isMoment(date) ? (
      <>
        {date.format('DD.MM.YYYY')}
        <br />
        {date.format('HH:mm')}
      </>
    ) : (
      'Не указано'
    )}
  </span>
);

const data = {
  startDate: {
    key: 'startDate',
    title: 'Начало',
    renderContent: (shutdown) => {
      const date = moment(shutdown.startDate);
      return renderDate(date);
    },
  },

  planEndDate: {
    key: 'planEndDate',
    title: 'Окончание (план)',
    renderContent: (shutdown) => {
      const date = moment(shutdown.planEndDate);
      return renderDate(date);
    },
  },

  executors: {
    key: 'executors',
    title: 'Ответственные',
    renderContent: (shutdown) => (
      <ExecutorList executors={shutdown.executors} />
    ),
  },
};

const ShutdownDetails = ({ shutdown }) => {
  const renderedData = Object.values(data);

  return (
    <div className={styles.root}>
      <div className={styles.row}>
        {renderedData.map((i) => (
          <div
            className={cn(styles.titleCell, styles.cell)}
            key={i.key}
          >
            {i.title}
          </div>
        ))}
      </div>

      <div className={styles.row}>
        {renderedData.map((i) => (
          <div
            key={i.key}
            className={cn(styles.contentCell, styles.cell)}
          >
            {i.renderContent(shutdown)}
          </div>
        ))}
      </div>

      <div className={styles.descRow}>
        <div className={cn(styles.cell, styles.titleCell)}>Описание</div>
        <div className={cn(styles.cell, styles.contentCell)}>
          <ShutdownDesc description={shutdown.description} />
        </div>
      </div>
    </div>
  );
};

export default ShutdownDetails;
